import gql from 'graphql-tag';

export const getCommercialFacilityHistories = gql`
  query getCommercialFacilityHistories($id: ID!) {
    getCommercialFacilityHistories(id: $id) {
      id
      version
      updatedAt
      updater
    }
  }
`;
